import PropTypes from 'prop-types';

import PageWrapper from '../../../components/Wrappers/PageWrapper/PageWrapper';
import ResetPasswordForm from '../../../components/Forms/ResetPasswordForm/ResetPasswordForm';
import { SectionWrapper, SectionContainer } from '../Login/Login.styles';

const ResetPassword = ({ variant }) => {
  return (
    <PageWrapper userType={'unauthenticated'} showSecondaryFooter>
      <SectionWrapper>
        <SectionContainer />
        <SectionContainer>
          <ResetPasswordForm variant={variant} />
        </SectionContainer>
      </SectionWrapper>
    </PageWrapper>
  );
};

ResetPassword.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

export default ResetPassword;
